<template>
    <!--todo:未完成-->
    <div class="login-page" style="background-color: rgba(242,255,250,0)">
        <div class="layer bg" id="login"></div>
        <span v-text="active"></span>
        <div style="width: 50%;margin-left: 25%;padding-top: 20%">
            <el-steps :active="active" finish-status="success">
                <el-step title="填写用户名"></el-step>
                <el-step title="验证身份"></el-step>
                <el-step title="设置新密码"></el-step>
                <el-step title="完成"></el-step>
            </el-steps>
            <el-form v-if="active===0" ref="form" :model="form" label-width="60px"
                     style="margin-top: 20px;margin-left: 0px">
                <el-form-item label="账户" prop="username"
                              :rules="[{required: true, message: '请输入用户名', trigger:[ 'blur','change']} ]">
                    <el-input v-model="form.username" placeholder="账户名"></el-input>
                </el-form-item>
                <el-form-item label="验证码" prop="code">
                    <el-input type="text" v-model="form.code" placeholder="验证码">
                        <template slot="append">
                            <img class="login-code" src="./image/login-code.png" height="35px">
                        </template>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">提交</el-button>
                    <el-button>取消</el-button>
                </el-form-item>
            </el-form>
            <el-form v-if="active===1" ref="form" :model="form" label-width="60px"
                     style="margin-top: 20px;margin-left: 0px">
                <el-form-item label="账户">
                    <el-input v-model="form.username" placeholder="账户名" disabled></el-input>
                </el-form-item>
                <el-form-item label="方式" prop="code">
                    <el-radio-group v-model="form.radio">
                        <el-radio :label="0">邮箱</el-radio>
                        <el-radio :label="1">电话</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item :label="form.radio===0?'邮箱':'电话'">
                    <el-input v-model="form.username" :placeholder="form.radio===0?'邮箱':'电话'"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="checkSubmit">提交</el-button>
                    <el-button>取消</el-button>
                </el-form-item>
            </el-form>
            <el-form v-if="active===2" ref="form" :model="form" label-width="60px"
                     style="margin-top: 20px;margin-left: 0px">
                <el-form-item label="账户">
                    <el-input v-model="form.username" placeholder="账户名" disabled></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="code">
                    <el-input v-model="form.newpwd" placeholder="新密码"></el-input>
                </el-form-item>
                <el-form-item label="重复">
                    <el-input v-model="form.newpwd2" placeholder="新密码"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="changeSubmit">提交</el-button>
                    <el-button>取消</el-button>
                </el-form-item>
            </el-form>
            <el-form v-if="active===4" ref="form" :model="form" label-width="60px"
                     style="margin-top: 20px;margin-left: 0px">
                <el-form-item>
                    <h1>密码重置完成
                        <el-button @click="login">现在登录</el-button>
                    </h1>
                </el-form-item>
            </el-form>
        </div>

    </div>
</template>

<script>
    /* eslint-disable */
    require('particles.js')
    import config from './config/default'
    import {mapActions} from 'vuex'


    export default {
        data() {
            return {
                active: 0,

                form: {
                    username: '',
                    password: '',
                    code: '',
                    radio: 0,
                    newpwd: 0,
                    newpwd2: 0,
                },
            }
        },
        mounted() {
            // 初始化例子插件
            particlesJS('login', config)
        },
        beforeDestroy() {
            // 销毁 particlesJS
            // thanks https://github.com/d2-projects/d2-admin/issues/65
            // ref https://github.com/VincentGarreau/particles.js/issues/63
            if (pJSDom && pJSDom.length > 0) {
                pJSDom[0].pJS.fn.vendors.destroypJS()
                pJSDom = []
            }
        },
        methods: {
            ...mapActions('d2admin/account', [
                'login'
            ]),
            /**
             * @description 提交表单
             */
            // 提交登录信息
            onSubmit() {
                const _this = this
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        _this.active = 1
                    }
                })

            },
            checkSubmit() {
                const _this = this
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        _this.active = 2
                    }
                })

            },
            changeSubmit() {
                const _this = this
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        _this.active = 4
                    }
                })

            },
            login() {
                window.location.href = 'login'
            }
        },
        created() {

        }
    }
</script>

<style lang="scss">
    @import './style.scss';
</style>
